import type { ServiceSignalKind } from '../../api/client'

export const STATUS_COPY: Record<ServiceSignalKind, { title: string; tone: 'warning' | 'danger' }> = {
  suggestions_paused: { title: 'AI 建議暫停', tone: 'warning' },
  classification_degraded: { title: 'AI 分類降級', tone: 'warning' },
  channel_disconnected: { title: '粉專已斷線', tone: 'danger' },
  publishing_failing: { title: 'Meta 發文失敗', tone: 'danger' },
  database_outage: { title: '服務暫時無法使用', tone: 'danger' },
}

export const STATUS_DETAIL_COPY = {
  since: '自',
  retryAt: '下次重試',
  outageBody: '我們正在恢復服務。為免顯示不完整的資料，這段時間不會載入佇列。',
  lastSynced: '最後成功同步',
  never: '尚未同步',
  reload: '重新載入',
  disconnectedChannels: (names: readonly string[]) => `${names.join('、')} 已斷線，請到「設定」重新連接`,
  failedClassification: (count: number) => `${count} 個項目未能自動分類，需要人手判斷`,
} as const

export const UPDATE_COPY = {
  title: '新版本已經部署',
  detail: '可以先完成手上的回覆，準備好再重新載入。',
  reload: STATUS_DETAIL_COPY.reload,
  preparing: '準備中…',
} as const
